import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f30910"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-plus" }, null, -1))
const _hoisted_5 = { class: "list-group" }
const _hoisted_6 = {
  key: 0,
  class: "list-group-item text-center text-danger"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_8 = { class: "text-truncate" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "attachmentModal",
    backdrop: "static",
    onHidden: _ctx.handleHidden
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("จัดการเอกสารแนบ ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mb-3",
          disabled: _ctx.isLoading,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadClick && _ctx.uploadClick(...args)))
        }, [
          _hoisted_4,
          _createTextVNode(" เพิ่มเอกสาร ")
        ], 8, _hoisted_3),
        _createElementVNode("ul", _hoisted_5, [
          (_ctx.attachments?.length === 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _hoisted_7,
                _createTextVNode("ไม่มีข้อมูล ")
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.attachments, (attachment, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "list-group-item list-group-item-action d-flex justify-content-between align-items-start"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(attachment.name), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "btn text-danger",
                    onClick: ($event: any) => (_ctx.deleleClick(attachment.id))
                  }, _hoisted_12, 8, _hoisted_10)
                ]))
              }), 128))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_14,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_13)
    ]),
    _: 1
  }, 8, ["onHidden"]))
}